import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';

import { statusMap } from '../utils';
import ExpirationCard from './ExpirationCard';

const ValidityProductCards = ({ data, loading, customClassName = '', hideLabels = false }) => {
  const isMobileScreen = useMediaQuery('(max-width: 600px)');
  const isDesktopScreen = useMediaQuery('(min-width: 1389px)');
  const history = useHistory();
  const { id: paramsID } = useParams();

  const handleClickExpirationCard = (labelStatus) => {
    history.push(`/etiquetas/catalogo/produtos/${paramsID}`, {
      labelStatus
    });
  };

  return (
    <Box px={2} py={3} className={`pt10 ${customClassName}`}>
      {!isDesktopScreen || customClassName && (
        <Typography
          className="title"
          style={{
            fontSize: 16,
            fontWeight: customClassName ? 400 : 600,
            color: '#1F2445',
            marginBottom: customClassName ? 10 : 20,
            textAlign: isMobileScreen ? 'center' : 'left'
          }}
        >
          CONTROLE OS VENCIMENTOS DOS SEUS PRODUTOS:
        </Typography>
      )}

      <div
        style={{
          width: '100%',
          justifyContent: isMobileScreen ? 'center' : 'flex-start',
          flexDirection: isMobileScreen ? 'column' : 'row',
          flexWrap: 'wrap',
          gap: 16
        }}
        className="dFlex wrap"
      >
        {loading ? (
          <CircularProgress />
        ) : (
          data.map((item) => {
            const map = statusMap[item.labelStatus] || {};
            return (
              <ExpirationCard
                key={item.labelStatus}
                quantity={item.total}
                label={map.label}
                mobileLabel={map?.mobileLabel}
                status={map.statusText}
                bgColor={map.color}
                date={map.date}
                hideLabels={hideLabels && isMobileScreen}
                onClick={() => {
                  handleClickExpirationCard(item.labelStatus);
                }}
              />
            );
          })
        )}
      </div>
    </Box>
  );
};

export default ValidityProductCards;
